import styled, { css } from 'styled-components';
import { makeStyles, createStyles, MuiTheme, GridDirection } from '@kis-technologies/kis-ui';

const raised = css`
  &:hover {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  }
`;

export const Key = styled.button<{ fontFamily?: string }>`
  font-family: ${({ fontFamily }) => fontFamily || 'Poppins, sans-serif'};
  font-weight: 400;
  width: auto;
  flex: 1;
  height: 104px;
  border-radius: 8px;
  width: 242px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  background-color: #ffffff;
  color: #000000;
  text-decoration: none;
  outline: none;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  svg {
    width: 50px;
    height: 50px;
  }
  ${raised};
`;

export const CaretContainer = styled.div`
  position: absolute;
  right: 25px;
  background: white;
  border-radius: 50px;
  padding: 14px 18px;
  top: -25px;
`;

export const useStyles = (props: { layout?: GridDirection; backLabel?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      numPadOuterContainer: {
        display: 'flex',
        padding: '0px 40px 10px',
        marginBottom: '15px',
        flexDirection: props.layout ? props.layout : 'row',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'column'
        }
      },
      numPadBlock: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        paddingTop: props.layout === 'column' ? 0 : '10px'
      },
      backLabelBlockLandscape: {
        alignSelf: 'flex-end',
        textAlign: 'center',
        padding: '20px 20px 0',
        [theme.breakpoints.down('lg')]: {
          display: 'none'
        }
      },
      backLabelBlockPortarait: {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
          display: 'flex',
          alignSelf: 'flex-end',
          textAlign: 'center',
          padding: '20px 20px 0'
        }
      },
      backLabelButton: {
        minWidth: '400px',
        maxWidth: 'fit-content',
        '& > span': {
          padding: '0px 15px 0px 0px'
        }
      },
      labelBlockContainer: {
        display: 'flex',
        justifyContent: 'space-around'
      },
      numPadLabelBlock: {
        alignSelf: 'flex-end',
        textAlign: 'center',
        padding: '15px 20px 0',
        [theme.breakpoints.down('lg')]: {
          display: props.backLabel ? 'flex' : 'block'
        }
      }
    })
  );
